<!-- Dialog title -->
<div mat-dialog-title>
  <div class="failure-popup-header d-flex justify-content-end">
    <img
      src="assets/icon/cross.svg"
      (click)="onClose()"
      class="cursor-pointer"
      alt="close"
    />
  </div>
</div>
<!-- Dialog content -->
<div>
  <div class="row">
    <div class="col-12 text-center">
      <div class="fail-gif">
        <img src="assets/gif/fail.gif" class="fail-gif-image" alt="close" />
        <!-- <p class="text-red gif-icon-text">Lorem Ipsum</p> -->
      </div>
    </div>
    <div class="col-12 message">
      {{ errorMessage }}
    </div>
    <div class="col-12 d-flex justify-content-center mt-2">
      <button
        class="submit-btn success-submission"
        type="submit"
        (click)="onClose()"
      >
        Cancel
      </button>
    </div>
  </div>
</div>
